import { EmergencyInstructionForm } from "~/components/form/health-profile/EmergencyInstructionForm";
import { Authorize } from "~/components/permission/Authorize";

export default function CreateInstruction() {
    return (
        <Authorize ability="update" section="profile">
            <EmergencyInstructionForm asRoute />
        </Authorize>
    );
}
